import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Table, Button, Form, InputGroup, Badge, Spinner, Modal, Pagination } from 'react-bootstrap';
import { getApiUrl } from '../config/api';

const DataDokter = () => {
  const navigate = useNavigate();
  const [time, setTime] = useState({ date: '', clock: '' });

  // Data Dokter State
  const [dokterList, setDokterList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fetchError, setFetchError] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSpesialisFilter, setSelectedSpesialisFilter] = useState('');
  const [selectedStatusFilter, setSelectedStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);


  // State Data Poli
  const [activeTab, setActiveTab] = useState('dokter');
  const [poliList, setPoliList] = useState([]);
  const [isLoadingPoli, setIsLoadingPoli] = useState(false);
  const [searchPoli, setSearchPoli] = useState('');

  const fetchPoli = async () => {
    setIsLoadingPoli(true);
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/show_poli`);
      const json = await response.json();
      if (json && json.list_poli) {
        setPoliList(json.list_poli);
      }
    } catch (err) {
      console.warn("Gagal fetch data poli:", err);
    } finally {
      setIsLoadingPoli(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'poli' && poliList.length === 0) {
      fetchPoli();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const filteredPoli = poliList.filter(item => 
    (item.nama || '').toLowerCase().includes(searchPoli.toLowerCase()) ||
    (item.kode || '').toLowerCase().includes(searchPoli.toLowerCase())
  );

  // Form State untuk Input/Edit Modal
  const [formNodok, setFormNodok] = useState('');
  const [formNamaDok, setFormNamaDok] = useState('');
  const [formSpecialis, setFormSpecialis] = useState('Spesialis Anasthesi');
  const [formStsPegawai, setFormStsPegawai] = useState('Non Pegawai');
  const [formNoSip, setFormNoSip] = useState('');
  const [formNoSp, setFormNoSp] = useState('');
  const [formNoSptp, setFormNoSptp] = useState('');
  const [formNoDir, setFormNoDir] = useState('-');
  const [formAlatDokter, setFormAlatDokter] = useState(0);
  const [formAlatRs, setFormAlatRs] = useState(0);
  const [formGarantifee, setFormGarantifee] = useState(0);
  const [formTransport, setFormTransport] = useState(0);
  const [formBank, setFormBank] = useState('');
  const [formNoRek, setFormNoRek] = useState('');
  const [formAn, setFormAn] = useState('');
  const [formCabang, setFormCabang] = useState('');
  const [formJln, setFormJln] = useState('');
  const [formNo, setFormNo] = useState('');
  const [formRt, setFormRt] = useState('');
  const [formKp, setFormKp] = useState('');
  const [formDesa, setFormDesa] = useState('');
  const [formKec, setFormKec] = useState('');
  const [formKota, setFormKota] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);

  // Fallback Mock Data matching requested response JSON
  const mockDokter = [
    {
      "alat_dokter": 0,
      "alat_rs": 0,
      "an": "ARIEF ISFIA JUNAIDY",
      "bank": "NISP",
      "cabang": "Bogor",
      "desa": "Limus Nunggal",
      "garantifee": 35000000,
      "jln": "Semarang VI Blok I 2",
      "kec": "Cileungsi",
      "kota": "Bogor",
      "kp": "Limus Pratama Regency",
      "nama_dok": "Arief Isfia Junaidy, dr,SpAN",
      "no": "22",
      "no_dir": "-",
      "no_rek": "045130007845",
      "no_sip": "445.9/1176/Dr/Diskes/2005",
      "no_sp": "KP.01.01.8.456",
      "no_sptp": "445.9/1176/Dr/Diskes/2005",
      "nodok": "0105",
      "rt": "01",
      "specialis": "Spesialis Anasthesi",
      "sts_pegawai3": "Non Pegawai",
      "transport": 0
    },
    {
      "alat_dokter": 95,
      "alat_rs": 5,
      "an": "RUSDI ARMAN",
      "bank": "BSM",
      "cabang": "Cibubur",
      "desa": "Jati Karya",
      "garantifee": 0,
      "jln": "Citra Gran Blok C",
      "kec": "Jati Sampurna",
      "kota": "Bekasi",
      "kp": "",
      "nama_dok": "Rusdi Arman, H, dr, SpB",
      "no": "33",
      "no_dir": "-",
      "no_rek": "1037007150",
      "no_sip": "445.9/610-2/Sp.B/Diskes/2007",
      "no_sp": "-",
      "no_sptp": "445.9/610/Dr/Diskes/2003",
      "nodok": "0106",
      "rt": "002",
      "specialis": "Spesialis Bedah Umum",
      "sts_pegawai3": "Non Pegawai",
      "transport": 0
    }
  ];

  // Fetch data dokter dari backend /show_dokter
  const fetchDokter = async () => {
    setIsLoading(true);
    setFetchError('');
    const apiUrl = getApiUrl();
    try {
      const response = await fetch(`${apiUrl}/show_dokter`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const json = await response.json();
      if (json && json.list_dokter) {
        setDokterList(json.list_dokter);
      } else {
        setDokterList(mockDokter);
      }
    } catch (err) {
      console.warn("Gagal terhubung ke backend /show_datadokter, menggunakan data lokal:", err);
      setDokterList(mockDokter);
      setFetchError("Menggunakan data lokal. Gagal terhubung ke server backend.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      setTime({
        date: now.toLocaleDateString('id-ID', options),
        clock: now.toLocaleTimeString('id-ID') + ' WIB'
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);

    fetchDokter();

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter List Dokter
  const filteredDokter = dokterList.filter(item => {
    const matchesSearch = 
      ((item.nama_dok || '').toLowerCase().includes(searchQuery.toLowerCase())) ||
      ((item.nodok || '').toLowerCase().includes(searchQuery.toLowerCase())) ||
      ((item.specialis || '').toLowerCase().includes(searchQuery.toLowerCase()));

    const matchesSpesialis = selectedSpesialisFilter ? item.specialis === selectedSpesialisFilter : true;
    const matchesStatus = selectedStatusFilter ? item.sts_pegawai3 === selectedStatusFilter : true;

    return matchesSearch && matchesSpesialis && matchesStatus;
  });

  // Unique filters lists
  const uniqueSpesialis = [...new Set(dokterList.map(d => d.specialis))].filter(Boolean);
  const uniqueStatus = [...new Set(dokterList.map(d => d.sts_pegawai3))].filter(Boolean);

  // Paginated List
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredDokter.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredDokter.length / itemsPerPage);

  // Pilih untuk di-edit
  const handleSelectEdit = (item) => {
    setFormNodok(item.nodok || '');
    setFormNamaDok(item.nama_dok || '');
    setFormSpecialis(item.specialis || 'Spesialis Anasthesi');
    setFormStsPegawai(item.sts_pegawai3 || 'Non Pegawai');
    setFormNoSip(item.no_sip || '');
    setFormNoSp(item.no_sp || '');
    setFormNoSptp(item.no_sptp || '');
    setFormNoDir(item.no_dir || '-');
    setFormAlatDokter(item.alat_dokter ?? 0);
    setFormAlatRs(item.alat_rs ?? 0);
    setFormGarantifee(item.garantifee ?? 0);
    setFormTransport(item.transport ?? 0);
    setFormBank(item.bank || '');
    setFormNoRek(item.no_rek || '');
    setFormAn(item.an || '');
    setFormCabang(item.cabang || '');
    setFormJln(item.jln || '');
    setFormNo(item.no || '');
    setFormRt(item.rt || '');
    setFormKp(item.kp || '');
    setFormDesa(item.desa || '');
    setFormKec(item.kec || '');
    setFormKota(item.kota || '');
    setIsEditing(true);
    setShowFormModal(true);
  };

  // Bersihkan form
  const handleClearForm = () => {
    setFormNodok('');
    setFormNamaDok('');
    setFormSpecialis('Spesialis Anasthesi');
    setFormStsPegawai('Non Pegawai');
    setFormNoSip('');
    setFormNoSp('');
    setFormNoSptp('');
    setFormNoDir('-');
    setFormAlatDokter(0);
    setFormAlatRs(0);
    setFormGarantifee(0);
    setFormTransport(0);
    setFormBank('');
    setFormNoRek('');
    setFormAn('');
    setFormCabang('');
    setFormJln('');
    setFormNo('');
    setFormRt('');
    setFormKp('');
    setFormDesa('');
    setFormKec('');
    setFormKota('');
    setIsEditing(false);
    setShowFormModal(false);
  };

  // Submit Simpan (Lokal)
  const handleSubmit = (e) => {
    e.preventDefault();
    const newRecord = {
      nodok: formNodok || `DOK-${Math.floor(Math.random() * 1000)}`,
      nama_dok: formNamaDok,
      specialis: formSpecialis,
      sts_pegawai3: formStsPegawai,
      no_sip: formNoSip,
      no_sp: formNoSp,
      no_sptp: formNoSptp,
      no_dir: formNoDir,
      alat_dokter: parseInt(formAlatDokter, 10),
      alat_rs: parseInt(formAlatRs, 10),
      garantifee: parseInt(formGarantifee, 10),
      transport: parseInt(formTransport, 10),
      bank: formBank,
      no_rek: formNoRek,
      an: formAn,
      cabang: formCabang,
      jln: formJln,
      no: formNo,
      rt: formRt,
      kp: formKp,
      desa: formDesa,
      kec: formKec,
      kota: formKota
    };

    if (isEditing) {
      setDokterList(prev => prev.map(d => d.nodok === formNodok ? newRecord : d));
    } else {
      setDokterList(prev => [...prev, newRecord]);
    }
    handleClearForm();
  };

  // Hapus Data (Lokal)
  const handleDelete = (nodok) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data dokter ini?")) {
      setDokterList(prev => prev.filter(d => d.nodok !== nodok));
    }
  };

  return (
    <div style={styles.appContainer}>
      {/* ══════════════ NAVBAR ══════════════ */}
      <nav className="navbar navbar-expand-xl navbar-dark shadow-sm" style={styles.navbarCustom}>
        <Container fluid>
          <a className="navbar-brand d-flex align-items-center me-3" href="#home" onClick={(e) => { e.preventDefault(); navigate('/home'); }}>
            <div className="d-flex align-items-center justify-content-center me-2 rounded bg-white bg-opacity-10 p-1">
              <i className="bi bi-shield-plus text-warning fs-4"></i>
            </div>
            <div>
              <div className="fw-bold text-white lh-1" style={{ fontSize: '0.95rem' }}>SIMRS2 <span className="text-teal" style={{ fontSize: '0.78rem' }}>Finance</span></div>
              <div className="text-white-50 small" style={{ fontSize: '0.62rem' }}>Sistem Informasi Rumah Sakit</div>
            </div>
          </a>

          <div className="d-flex align-items-center text-white text-end gap-3 ms-auto">
            <div className="small border-end pe-3 border-light border-opacity-25 d-none d-sm-block">
              <div className="fw-semibold text-white-50" style={{ fontSize: '0.73rem' }}>{time.date}</div>
              <div className="fw-bold text-teal" style={{ fontSize: '0.78rem' }}>{time.clock}</div>
            </div>
            
            <Button variant="light" size="sm" onClick={() => navigate('/home')} className="d-flex align-items-center gap-1">
              <i className="bi bi-house-door-fill text-teal"></i>
              <span>Kembali</span>
            </Button>
          </div>
        </Container>
      </nav>

      {/* ══════════════ CORE MAIN CONTENT ══════════════ */}
      <div style={styles.mainContent}>
        <Row className="g-3">
          
          <Col lg={12}>
            <Card style={styles.mainCard} className="shadow-sm border-0 h-100">
              <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }} className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <span className="fw-bold"><i className="bi bi-person-badge-fill me-1 text-warning"></i> Master Data Medis & Poliklinik</span>
                <div className="d-flex gap-2 align-items-center">
                  <Button variant="teal" size="sm" onClick={() => { handleClearForm(); setShowFormModal(true); }} className="d-flex align-items-center gap-1.5 fw-bold px-3 py-1.5" style={{ fontSize: '0.73rem', background: '#0d9488', border: 'none' }}>
                    <i className="bi bi-plus-circle-fill"></i> Registrasi Dokter Baru
                  </Button>
                  <Button variant="outline-light" size="sm" onClick={fetchDokter} disabled={isLoading} style={{ fontSize: '0.7rem' }}>
                    {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Reload
                  </Button>
                </div>
              </div>

              <Card.Body className="p-2 d-flex flex-column h-100" style={{ minHeight: 0 }}>
                {/* TABS */}
                <div className="d-flex gap-2 mb-3 border-bottom pb-2">
                  <Button 
                    variant={activeTab === 'dokter' ? 'primary' : 'light'} 
                    size="sm" 
                    onClick={() => setActiveTab('dokter')}
                    className="fw-bold"
                  >
                    <i className="bi bi-person-lines-fill me-1"></i> Data Dokter
                  </Button>
                  <Button 
                    variant={activeTab === 'poli' ? 'success' : 'light'} 
                    size="sm" 
                    onClick={() => setActiveTab('poli')}
                    className="fw-bold"
                  >
                    <i className="bi bi-building-fill me-1"></i> Data Poli
                  </Button>
                </div>


                {activeTab === 'dokter' ? (
                  <>
                    {/* Search Bar & Filter Row */}
                <Row className="g-2 mb-3">
                  <Col md={4}>
                    <InputGroup size="sm">
                      <InputGroup.Text className="bg-light text-muted border-slate"><i className="bi bi-search"></i></InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Cari Dokter (Kode, Nama, Spesialis)..."
                        value={searchQuery}
                        onChange={(e) => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                        style={{ fontSize: '0.78rem' }}
                      />
                    </InputGroup>
                  </Col>

                  {/* Filter Spesialis */}
                  <Col md={3}>
                    <Form.Select 
                      size="sm" 
                      value={selectedSpesialisFilter} 
                      onChange={(e) => { setSelectedSpesialisFilter(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value="">Semua Spesialis</option>
                      {uniqueSpesialis.map((s, i) => <option key={i} value={s}>{s}</option>)}
                    </Form.Select>
                  </Col>

                  {/* Filter Status Pegawai */}
                  <Col md={3}>
                    <Form.Select 
                      size="sm" 
                      value={selectedStatusFilter} 
                      onChange={(e) => { setSelectedStatusFilter(e.target.value); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value="">Semua Status</option>
                      {uniqueStatus.map((st, i) => <option key={i} value={st}>{st}</option>)}
                    </Form.Select>
                  </Col>

                  {/* Paginasi Limit per Page */}
                  <Col md={2}>
                    <Form.Select 
                      size="sm" 
                      value={itemsPerPage} 
                      onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                      style={{ fontSize: '0.78rem' }}
                    >
                      <option value={10}>10 Baris</option>
                      <option value={20}>20 Baris</option>
                      <option value={50}>50 Baris</option>
                      <option value={100}>100 Baris</option>
                    </Form.Select>
                  </Col>
                </Row>

                {/* Table Area */}
                {fetchError && (
                  <div className="alert alert-warning py-1.5 px-3 mb-2.5" style={{ fontSize: '0.75rem' }}>
                    <i className="bi bi-exclamation-triangle-fill me-1"></i> {fetchError}
                  </div>
                )}

                <div className="table-responsive flex-grow-1" style={{ overflowY: 'auto', minHeight: '380px' }}>
                  <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                    <thead className="table-light text-secondary sticky-top">
                      <tr>
                        <th style={{ width: '80px' }}>Kode</th>
                        <th>Nama Dokter</th>
                        <th>Spesialisasi</th>
                        <th>Status</th>
                        <th>No SIP / SP</th>
                        <th>Jasa Medis</th>
                        <th>Rekening Bank</th>
                        <th>Alamat Praktik</th>
                        <th style={{ width: '100px' }} className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="9" className="text-center py-5 text-muted">
                            <Spinner animation="border" variant="teal" className="mb-2" />
                            <div>Memuat data dokter...</div>
                          </td>
                        </tr>
                      ) : currentItems.length > 0 ? (
                        currentItems.map((item, idx) => (
                          <tr key={idx}>
                            <td className="fw-bold text-dark-blue">{item.nodok}</td>
                            <td className="fw-bold">{item.nama_dok}</td>
                            <td>
                              <Badge bg="info" text="dark" style={styles.badgeStyle}>
                                {item.specialis}
                              </Badge>
                            </td>
                            <td>
                              <Badge bg={item.sts_pegawai3 === 'Pegawai' ? 'success' : 'secondary'} style={styles.badgeStyle}>
                                {item.sts_pegawai3}
                              </Badge>
                            </td>
                            <td>
                              <div>SIP: <span className="font-monospace text-muted">{item.no_sip}</span></div>
                              <div>SP: <span className="font-monospace text-muted">{item.no_sp}</span></div>
                            </td>
                            <td>
                              <div>Alat Dok: {item.alat_dokter}% / RS: {item.alat_rs}%</div>
                              {item.garantifee > 0 && <div className="text-success small fw-bold">Garansi Fee: Rp {item.garantifee?.toLocaleString('id-ID')}</div>}
                            </td>
                            <td>
                              <div className="fw-bold">{item.bank} - {item.no_rek}</div>
                              <div className="text-muted small">a/n {item.an}</div>
                              {item.cabang && <div className="text-muted small">Cab. {item.cabang}</div>}
                            </td>
                            <td>
                              <div>{item.jln} {item.no && `No. ${item.no}`} {item.rt && `RT ${item.rt}`}</div>
                              <div className="text-muted small">{item.desa} {item.kec && `Kec. ${item.kec}`} {item.kota && `, ${item.kota}`}</div>
                            </td>
                            <td className="text-center">
                              <div className="d-flex justify-content-center gap-1">
                                <Button size="sm" variant="outline-primary" onClick={() => handleSelectEdit(item)} style={styles.actionBtn}>
                                  <i className="bi bi-pencil-fill"></i>
                                </Button>
                                <Button size="sm" variant="outline-danger" onClick={() => handleDelete(item.nodok)} style={styles.actionBtn}>
                                  <i className="bi bi-trash-fill"></i>
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center py-4 text-muted">
                            Tidak ada data dokter yang cocok.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="d-flex justify-content-center mt-3">
                    <Pagination size="sm" className="mb-0">
                      <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                      <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                      {[...Array(totalPages)].map((_, index) => (
                        <Pagination.Item
                          key={index + 1}
                          active={index + 1 === currentPage}
                          onClick={() => setCurrentPage(index + 1)}
                        >
                          {index + 1}
                        </Pagination.Item>
                      ))}
                      <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                      <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                    </Pagination>
                  </div>
                )}

                {/* Footer Info */}
                <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top text-muted small" style={{ fontSize: '0.72rem' }}>
                  <span>
                    Menampilkan <strong>{filteredDokter.length > 0 ? indexOfFirstItem + 1 : 0} - {Math.min(indexOfLastItem, filteredDokter.length)}</strong> dari <strong>{filteredDokter.length}</strong> data dokter (Total: {dokterList.length})
                  </span>
                  <span>IP Server: <strong>{getApiUrl()}</strong></span>
                </div>
                  </>
                ) : (
                  <div className="d-flex flex-column h-100">
                    <Row className="g-2 mb-3">
                      <Col md={5}>
                        <InputGroup size="sm">
                          <InputGroup.Text className="bg-light"><i className="bi bi-search"></i></InputGroup.Text>
                          <Form.Control 
                            placeholder="Cari kode atau nama poli..." 
                            value={searchPoli} 
                            onChange={(e) => setSearchPoli(e.target.value)}
                            style={{ fontSize: '0.78rem' }}
                          />
                        </InputGroup>
                      </Col>
                      <Col md={7} className="text-end">
                        <Button variant="outline-secondary" size="sm" onClick={fetchPoli} disabled={isLoadingPoli} style={{ fontSize: '0.78rem' }}>
                          <i className={`bi bi-arrow-clockwise ${isLoadingPoli ? 'spin' : ''}`}></i> Refresh
                        </Button>
                      </Col>
                    </Row>
                    <div className="table-responsive flex-grow-1" style={{ overflowY: 'auto', minHeight: '380px' }}>
                      <Table responsive striped bordered hover size="sm" className="align-middle mb-0" style={{ fontSize: '0.78rem' }}>
                        <thead className="table-light text-secondary sticky-top">
                          <tr>
                            <th style={{ width: '80px', textAlign: 'center' }}>No</th>
                            <th style={{ width: '120px' }}>Kode Poli</th>
                            <th>Nama Poliklinik</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoadingPoli ? (
                            <tr>
                              <td colSpan="3" className="text-center py-5 text-muted">
                                <Spinner animation="border" variant="success" className="mb-2" />
                                <div>Memuat data poliklinik...</div>
                              </td>
                            </tr>
                          ) : filteredPoli.length > 0 ? (
                            filteredPoli.map((item, idx) => (
                              <tr key={idx}>
                                <td className="text-center text-muted fw-bold">{idx + 1}</td>
                                <td className="fw-bold font-monospace text-success">{item.kode}</td>
                                <td className="fw-bold">{item.nama}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-4 text-muted">
                                <i className="bi bi-inbox fs-2 d-block mb-2 opacity-50"></i>
                                Tidak ada data poli yang ditemukan.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}

              </Card.Body>
            </Card>
          </Col>

        </Row>
      </div>

      {/* ══════════════ MODAL FORM ENTRI/EDIT DATA DOKTER ══════════════ */}
      <Modal show={showFormModal} onHide={handleClearForm} centered backdrop="static" size="xl">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#ffffff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-person-badge-fill text-warning fs-5"></i>
            <span>{isEditing ? `Edit Profil Dokter: ${formNamaDok}` : 'Registrasi Dokter Baru'}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSubmit}>
            
            <h6 className="border-bottom pb-1 mb-2 text-primary fw-bold" style={{ fontSize: '0.8rem' }}><i className="bi bi-person-lines-fill me-1"></i> Data Identitas & Legalitas</h6>
            <Row className="g-2 mb-3">
              {/* Kode Dokter */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kode Dokter (nodok)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: 0105"
                    value={formNodok}
                    onChange={(e) => setFormNodok(e.target.value)}
                    disabled={isEditing}
                    required
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Nama Dokter */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Dokter & Gelar</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: dr. Arief Isfia J., Sp.AN"
                    value={formNamaDok}
                    onChange={(e) => setFormNamaDok(e.target.value)}
                    required
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Spesialis */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Spesialisasi</Form.Label>
                  <Form.Select 
                    value={formSpecialis} 
                    onChange={(e) => setFormSpecialis(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Spesialis Anasthesi">Spesialis Anasthesi</option>
                    <option value="Spesialis Bedah Umum">Spesialis Bedah Umum</option>
                    <option value="Spesialis Penyakit Dalam">Spesialis Penyakit Dalam</option>
                    <option value="Spesialis Anak & Perinatologi">Spesialis Anak & Perinatologi</option>
                    <option value="Spesialis Kebidanan & Kandungan">Spesialis Kebidanan & Kandungan</option>
                    <option value="Dokter Umum / Poliklinik">Dokter Umum / Poliklinik</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              {/* Status Pegawai */}
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Status Kepegawaian</Form.Label>
                  <Form.Select 
                    value={formStsPegawai} 
                    onChange={(e) => setFormStsPegawai(e.target.value)}
                    style={styles.formSelect}
                  >
                    <option value="Non Pegawai">Non Pegawai</option>
                    <option value="Pegawai">Pegawai</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-3">
              {/* No SIP */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. SIP (Surat Izin Praktik)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNoSip}
                    onChange={(e) => setFormNoSip(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* No SP */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. SP</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNoSp}
                    onChange={(e) => setFormNoSp(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* No SPTP */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. SPTP</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNoSptp}
                    onChange={(e) => setFormNoSptp(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* No Dir */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. Dir</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNoDir}
                    onChange={(e) => setFormNoDir(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h6 className="border-bottom pb-1 mb-2 text-primary fw-bold" style={{ fontSize: '0.8rem' }}><i className="bi bi-wallet2 me-1"></i> Data Jasa Medis & Perbankan</h6>
            <Row className="g-2 mb-3">
              {/* Jasa Alat Dokter */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Bagi Jasa Alat Dokter (%)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAlatDokter}
                    onChange={(e) => setFormAlatDokter(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Jasa Alat RS */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Bagi Jasa Alat RS (%)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formAlatRs}
                    onChange={(e) => setFormAlatRs(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Garantifee */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Guarantee Fee / Gaji Tetap (Rp)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formGarantifee}
                    onChange={(e) => setFormGarantifee(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Transport */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Biaya Transportasi (Rp)</Form.Label>
                  <Form.Control
                    type="number"
                    value={formTransport}
                    onChange={(e) => setFormTransport(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-3">
              {/* Bank */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Bank</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Contoh: BCA / BNI / NISP"
                    value={formBank}
                    onChange={(e) => setFormBank(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* No Rekening */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. Rekening</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNoRek}
                    onChange={(e) => setFormNoRek(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Atas Nama */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Rekening Atas Nama (an)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formAn}
                    onChange={(e) => setFormAn(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Cabang */}
              <Col md={3}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Cabang Bank</Form.Label>
                  <Form.Control
                    type="text"
                    value={formCabang}
                    onChange={(e) => setFormCabang(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h6 className="border-bottom pb-1 mb-2 text-primary fw-bold" style={{ fontSize: '0.8rem' }}><i className="bi bi-geo-alt-fill me-1"></i> Data Alamat Praktik / Rumah</h6>
            <Row className="g-2 mb-3">
              {/* Jalan */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Jalan / Perumahan (jln)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formJln}
                    onChange={(e) => setFormJln(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* No Rumah */}
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>No. Rumah</Form.Label>
                  <Form.Control
                    type="text"
                    value={formNo}
                    onChange={(e) => setFormNo(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* RT */}
              <Col md={2}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>RT</Form.Label>
                  <Form.Control
                    type="text"
                    value={formRt}
                    onChange={(e) => setFormRt(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* KP */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Nama Kompleks / Kampung (kp)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formKp}
                    onChange={(e) => setFormKp(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="g-2 mb-3">
              {/* Desa */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Desa / Kelurahan (desa)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formDesa}
                    onChange={(e) => setFormDesa(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Kecamatan */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kecamatan (kec)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formKec}
                    onChange={(e) => setFormKec(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>

              {/* Kota */}
              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.73rem' }}>Kota / Kabupaten (kota)</Form.Label>
                  <Form.Control
                    type="text"
                    value={formKota}
                    onChange={(e) => setFormKota(e.target.value)}
                    style={styles.formControl}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Actions */}
            <div className="d-flex justify-content-end gap-2 border-top pt-2.5">
              <Button type="button" variant="secondary" size="sm" onClick={handleClearForm}>
                Batal
              </Button>
              <Button type="submit" variant="teal" size="sm" className="fw-bold" style={styles.btnSave}>
                <i className="bi bi-hdd-fill me-1"></i> Simpan Data Dokter
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex',
    flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem',
    flexShrink: 0,
  },
  mainContent: {
    flex: 1,
    padding: '0.4rem',
    overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px',
    border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff',
    overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem',
    color: '#ffffff',
    fontWeight: 600,
    fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
  formControl: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  formSelect: {
    fontSize: '0.75rem',
    borderRadius: '6px',
    padding: '0.35rem 0.6rem',
    border: '1px solid #cbd5e1',
    color: '#0f172a',
  },
  btnSave: {
    background: '#0d9488',
    borderColor: '#0d9488',
    color: '#ffffff',
    fontSize: '0.78rem',
  },
  actionBtn: {
    padding: '0.2rem 0.4rem',
    fontSize: '0.7rem',
  },
  badgeStyle: {
    fontSize: '0.7rem',
    fontWeight: '600',
    padding: '3px 7px',
    borderRadius: '20px',
  }
};

export default DataDokter;
